import Staked from './Staked';

export default {
  path: 'dapps/staked',
  component: Staked,
  props: true
};
